import AssetLoadingConfigType, { LoadingType } from './AssetLoadingConfigType';

const audioAssetPathConfig: AssetLoadingConfigType = {
    bundleName: 'resources',
    uniqueID: 'audioClip',
    path: {
        audioClip: {
            audioClip: {
                type: LoadingType.PRELOAD,
                path: '',
                isDir: true,
            },
        },
    },
};

export default audioAssetPathConfig;
